import React from 'react';
import PropTypes from 'prop-types';

import RadioOff from '@strava/icons/ActionsRadioOffSmall';
import RadioOn from '@strava/icons/ActionsRadioOnSmall';

import { color as colors } from '@strava/ui-tokens/js';
import styles from './styles.module.scss';

const Radio = ({
  id,
  name,
  value,
  color,
  checked,
  disabled,
  className,
  onChange
}) => {
  const classNames = [styles.radio, className];

  return (
    <span
      className={classNames.join(' ')}
      role="radio"
      aria-checked={checked}
      tabIndex={0}
    >
      <input
        type="radio"
        id={id}
        name={name}
        value={value}
        checked={checked}
        disabled={disabled}
        onChange={onChange}
        tabIndex={-1}
      />

      {checked ? <RadioOn fill={color} /> : <RadioOff />}
    </span>
  );
};

Radio.defaultProps = {
  color: colors.colorCoreO3,
  checked: false,
  disabled: false,
  className: null,
  onChange: () => {}
};

Radio.propTypes = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  color: PropTypes.string,
  value: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  onChange: PropTypes.func
};

export default Radio;
